import { SvgIcon } from '../styled-components';
import { SvgIconProps } from '@material-ui/core/SvgIcon';

const DotsIcon: React.FC<SvgIconProps> = ({
  viewBox = '0 0 16 16',
  ...rest
}) => (
  <SvgIcon {...rest} viewBox={viewBox}>
    <circle cx="2" cy="2" r="2"></circle>
    <circle cx="8" cy="2" r="2"></circle>
    <circle cx="14" cy="2" r="2"></circle>
    <circle cx="2" cy="8" r="2"></circle>
    <circle cx="8" cy="8" r="2"></circle>
    <circle cx="14" cy="8" r="2"></circle>
    <circle cx="2" cy="14" r="2"></circle>
    <circle cx="8" cy="14" r="2"></circle>
    <circle cx="14" cy="14" r="2"></circle>
  </SvgIcon>
);

export default DotsIcon;
